import { createResource } from 'react-resource-router';
const TWENTY_FOUR_HOURS_IN_MS = 86400000;
export const knowledgeSourcesResource = createResource({
  type: 'CSM_AGENT_CONFIGURATION_KNOWLEDGE_SOURCES',
  getKey: routerContext => `knowledge-sources-${routerContext.query.agentId}`,
  getData: routerContext => import( /* webpackChunkName: "ai-mate/csm-knowledge-config-resource" */'./get-data').then(module => module.default(routerContext.query.agentId)),
  maxAge: TWENTY_FOUR_HOURS_IN_MS,
  isBrowserOnly: true
});